import { Map } from 'immutable'
import {
  SET_PM_NODE,
  SET_PM_NODES,
  SET_PM_NODES_ERROR,
  SET_PM_NODES_PROCESSING,
  UPDATE_PM_NODES_SUCCESS,
  SET_PM_NODE_PROCESSING,
} from './actions'

export const initialState = Map({
  nodes: Map(),
})

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_PM_NODES_PROCESSING:
      return state.setIn(['processing'], true)
    case SET_PM_NODE_PROCESSING:
      return state.update('nodes', (map) => {
        const returnVal = map.setIn([payload, 'processing'], true)
        return returnVal
      })
    case SET_PM_NODE:
      return state
        .update('nodes', (map) => {
          const returnVal = map.set(payload.id, payload.data.set('processing', false))
          return returnVal
        })
        .setIn(['processing'], false)
    case SET_PM_NODES:
      return state.set('nodes', payload.data.merge(state.get('nodes'))).setIn(['processing'], false)
    case SET_PM_NODES_ERROR:
      return state.setIn(['error'], payload.error).setIn(['processing'], false)
    case UPDATE_PM_NODES_SUCCESS:
      return state.setIn(['success'], true).setIn(['processing'], false)
    default:
      return state
  }
}
